import { render, staticRenderFns } from "./FormControl.vue?vue&type=template&id=97b0513e&scoped=true&"
import script from "./FormControl.vue?vue&type=script&lang=js&"
export * from "./FormControl.vue?vue&type=script&lang=js&"
import style0 from "./FormControl.vue?vue&type=style&index=0&id=97b0513e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b0513e",
  null
  
)

export default component.exports